import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const notificationsApi = createApi({
    reducerPath: 'notificationsApi',
    tagTypes: ['notifications'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getNotifications: build.query({
            query: ({id, ...data}) => ({
                url: api.notifications.getNotifications(),
                method: 'GET',
                params: data
            }),
            providesTags: ['notifications'],
        }),
        markAllAsRead: build.mutation({
            query: (data) => ({
                url: api.notifications.markAllAsRead(),
                method: 'PUT',
                params: data
            }),
            invalidatesTags: ['notifications']
        }),
        markAsRead: build.mutation({
            query: ({id, ...data}) => ({
                url: api.notifications.markAsRead(id),
                method: 'PUT',
                params: data
            }),
            invalidatesTags: ['notifications']
        }),
    })
})

export const {useLazyGetNotificationsQuery, useMarkAllAsReadMutation, useMarkAsReadMutation} = notificationsApi
